import React, {Component} from 'react';
import ReactQueryParams from 'react-query-params';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';

import './App.css';

import 'font-awesome/css/font-awesome.css'


//import $ from "jquery";
import TemporalCategoriesFilter from './components/TemporalCategoriesFilter'
import GeographicFilter from './components/GeographicFilter'
import PersonNetwork from './components/PersonNetwork'
import KeywordsViewer from './components/KeywordsViewer'
import EntitiesViewer from './components/Entities'
import DocumentList from './components/DocumentList'
import TextSearch from './components/TextSearch'
import CoOccurrencesViewer from './components/CoOccurrencesViewer'
import Spacer from './components/Spacer'
import {render, unmountComponentAtNode} from "react-dom";
import Document from "./components/Document";
import { NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
class App extends ReactQueryParams {



    constructor(props) {
        super(props);
        this.state = {performActionFromUrl :false};


        if (Object.keys(this.queryParams).length === 0){
            this.state.performActionFromUrl = false
        }else{
            this.state.performActionFromUrl = true
        }


        // const { history } = this.props;

    }


    filterListByYear(year) {
        this.refs.document_list.filterItemsByYear(year);
    }

    clickOnLocation(location) {

        if (!location.features[0].properties.cited) {

            // document.getElementById('tool-column').style.backgroundColor  = '#0a91ed'
            this.refs.document_list.getFileListFromDBGeo({
                corpusID: "deg",
                rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                fileList: JSON.stringify(this.state.fromTo.filteredFiles),
                location: location.features[0].properties.name,
                background: "#54abdf"
            }, () => {
                this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
            })
        } else {
            this.refs.document_list.getFileListFromDBGeoCited({
                fileList: JSON.parse(location.features[0].properties.fileList),
                location: location.features[0].properties.name,
                background: "#54abdf"
            }, () => {
                this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
            })

        }
    }

    clickOnPerson(person) {
        let state = this.state;
        // document.getElementById('tool-column').style.backgroundColor  = '#9d0cea'
        this.refs.document_list.getFileListFromDBPerson({
            corpusID: "deg",
            rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
            sortmethod: "dataInsertion",
            sortdirection: "ASC",
            fileList: JSON.stringify(this.state.fromTo.filteredFiles),
            keyword: JSON.stringify(person),
            background: "#9e5aa6"
        }, () => {
            this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
        })
    }


    textSearchOutput(fileList) {
        let parameters = {}
        parameters.data = fileList;
        parameters.background = '#ec9943';
        this.refs.document_list.setFileListFromJson(parameters, () => {
            this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
        });
    }


    lemmaDocByYear(data) {
        this.refs.document_list.getFileListLemmaByYear({
            corpusID: "deg",
            year: data.year,
            sortmethod: "dataInsertion",
            sortdirection: "ASC",
            fileList: JSON.stringify(this.state.fromTo.filteredFiles),
            term: data.term,
            background: "#ec9943"
        }, () => {
            //   this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
        })
    }


    clickOccurrenceNode(fileList) {
        this.refs.document_list.getFileListFromDB({
            corpusID: "deg",
            rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
            sortmethod: "dataInsertion",
            sortdirection: "ASC",
            fileList: JSON.stringify(fileList),
            background: "#a4becb"
        }, () => {
            this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
        })
    }


    clickOnKeyword(keyword) {
        // document.getElementById('tool-column').style.backgroundColor  = '#2dc168'
        this.refs.document_list.getFileListFromDBKeyword(
            {
                corpusID: "deg",
                rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                fileList: JSON.stringify(this.state.fromTo.filteredFiles),
                keyword: keyword,
                background: "#86c069"
            }, () => {
                this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
            })
    }


    clickOnEntity(entity) {
        // document.getElementById('tool-column').style.backgroundColor  = '#2dc168'
        this.refs.document_list.getFileListFromDBEntities(
            {
                corpusID: "deg",
                rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                fileList: JSON.stringify(this.state.fromTo.filteredFiles),
                keyword: entity,
                background: "#c0501a"
            }, () => {
                this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
            })
    }


    fromToChange(newState) {
        this.setState({fromTo: newState}, () => {
            if (this.refs.document_list !== undefined) {
                // document.getElementById('tool-column').style.backgroundColor  = '#db0542'
                this.refs.document_list.getFileListFromDB({
                    corpusID: "deg",
                    rangeYears: newState.fromDate + "-" + newState.toDate,
                    sortmethod: "dataInsertion",
                    sortdirection: "ASC",
                    fileList: JSON.stringify(newState.filteredFiles),
                    background: "#d65d57"
                }, () => {
                    this.refs.temporal_category_widget.updateChart(this.refs.document_list.state.items)
                    setTimeout(() => {
                        this.refs.geographical_widget.update({
                            corpusID: "deg",
                            rangeYears: newState.fromDate + "-" + newState.toDate,
                            sortmethod: "dataInsertion",
                            sortdirection: "ASC",
                            fileList: JSON.stringify(newState.filteredFiles)
                        })
                    }, 300)

                    setTimeout(() => {
                        this.refs.keyword_widget.update({
                            corpusID: "deg",
                            rangeYears: newState.fromDate + "-" + newState.toDate,
                            sortmethod: "dataInsertion",
                            sortdirection: "ASC",
                            limit: 12,
                            fromTo: newState,
                            fileList: JSON.stringify(newState.filteredFiles)
                        })
                    }, 100)

                    setTimeout(() => {
                        this.refs.entities_widget.update({
                            corpusID: "deg",
                            rangeYears: newState.fromDate + "-" + newState.toDate,
                            sortmethod: "dataInsertion",
                            sortdirection: "ASC",
                            limit: 12,
                            fromTo: newState,
                            fileList: JSON.stringify(newState.filteredFiles)
                        })
                    }, 100)

                    setTimeout(() => {
                        this.refs.person_network_widget.update({
                            corpusID: "deg",
                            rangeYears: newState.fromDate + "-" + newState.toDate,
                            sortmethod: "dataInsertion",
                            sortdirection: "ASC",
                            range_extent: 1,
                            interval: 1,
                            extraction_method: "sentences",
                            fromTo: newState,
                            fileList: JSON.stringify(newState.filteredFiles)
                        })
                    }, 100)


                    this.refs.textsearch_widget.updateTimeInterval(newState,()=>{
                        if (this.queryParams.fullTextSearch !== undefined && this.state.performActionFromUrl) {
                            if (this.queryParams.fullTextSearch.length > 0) {
                                this.refs.textsearch_widget.performFulltextSearch(decodeURIComponent(this.queryParams.fullTextSearch))
                                this.setState({
                                    performActionFromUrl : false
                                })
                            }
                        }

                        if (this.queryParams.lemmaTextSearch !== undefined && this.state.performActionFromUrl) {
                            if (this.queryParams.lemmaTextSearch.length > 0) {
                                this.refs.textsearch_widget.performLemmatextSearch(decodeURIComponent(this.queryParams.lemmaTextSearch))
                                this.setState({
                                    performActionFromUrl : false
                                })
                            }
                        }

                    });





                    this.refs.cooccurrences_widget.updateTimeInterval(newState, ()=> {
                        if (this.queryParams.cooccurenceSearch !== undefined) {
                            if (this.queryParams.cooccurenceSearch.length > 0 && this.state.performActionFromUrl) {
                                this.refs.cooccurrences_widget.searchCoOccurrences(this.queryParams.cooccurenceSearch)
                                this.setState({
                                    performActionFromUrl : false
                                })
                            }
                        }
                    });




                    




                    //console.log( this.refs.document_list.state.items);
                })
            }


        })
    }

    componentDidMount() {
        // capture parameters from url
        console.log(this.queryParams);


        if (this.queryParams.doc) {
            this.loadDocumentFromParams()
        }

        if (this.queryParams.goto) {
            document.getElementById("analises_column").scrollTop = document.getElementById(this.queryParams.goto).offsetTop - document.getElementById("TemporalWidget_Container").offsetHeight
        }

        // this.fromToChange({
        //     fromDate: 1901, toDate: 1954, filteredFiles: []
        // })




}


    loadDocumentFromParams() {

        if (this.queryParams.doc) {
            unmountComponentAtNode(document.getElementById("document_viewer"))
            render(<Document id={this.queryParams.doc}/>, document.getElementById("document_viewer"))
        }


    }

    render() {
        return (
            <div className="mainAppContent">
                <div id="textOnEmpty">
                    <center><p>Alcide</p><p style={{fontSize: "1vmax"}}>Un viaggio negli scritti di De Gasperi</p></center>
                </div>
                <div className="row" style={{height: "100%"}}>
                    <div id="tool-column" className="col-md-3" style={{padding: "0px", height: "100%"}}>
                        <div className="col-header"><span>&nbsp;<a href="http://alcidedigitale.fbk.eu" style={{color:"#fff",textDecoration:"none"}}> <i className="fa fa-reply" aria-hidden="true" style={{zIndex:"10000000"}}/></a></span></div>
                        <div id="analises_column" className="colScrollable">
                            <div>
                                <Spacer/>
                                <TemporalCategoriesFilter ref={"temporal_category_widget"} callbackParent={(fromTo) => this.fromToChange(fromTo)} callbackParentSelectedYear={(year) => this.filterListByYear(year)} tags={{tags: this.queryParams.tags}} fromTo={{from: this.queryParams.from, to: this.queryParams.to}}/>
                                <KeywordsViewer ref={"keyword_widget"} callbackParent={(keyword) => this.clickOnKeyword(keyword)}/>
                                <TextSearch ref={"textsearch_widget"} callbackParent={(fileList) => this.textSearchOutput(fileList)} callbackParentSelectedYear={(data) => this.lemmaDocByYear(data)} callbackParentSelectedYearFullText={(data) => this.filterListByYear(data)}/>
                                <CoOccurrencesViewer ref={"cooccurrences_widget"} callbackParent={(fileList) => this.clickOccurrenceNode(fileList)} search={"Europa"}/>
                                <EntitiesViewer ref={"entities_widget"} callbackParent={(entity) => this.clickOnEntity(entity)}/>
                                <GeographicFilter ref={"geographical_widget"} callbackParent={(location) => this.clickOnLocation(location)} changeGeographicExtraction={(extraction) => this.fromToChange(this.state.fromTo)}/>
                                <PersonNetwork ref={"person_network_widget"} callbackParent={(person) => this.clickOnPerson(person)}/>
                            </div>
                        </div>
                    </div>
                    <div id="results-column" className="col-md-3" style={{padding: "0px", height: "100%"}}>
                        <DocumentList ref={"document_list"}/>
                    </div>
                    <div className="col-md-6" style={{padding: "0px", height: "100%"}}>
                        <div  className="colScrollable" id="document_viewer">
                        </div>
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js